module.exports = __webpack_public_path__ + "static/img/PC-2.220254b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/PC-2.png
// module id = IFpV
// module chunks = 0